import { render } from "./TemplateCollectionItem.vue?vue&type=template&id=24bb3ebc"
import script from "./TemplateCollectionItem.vue?vue&type=script&lang=js"
export * from "./TemplateCollectionItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__